import { WindowRef } from '@aca-new/app/shared/classes/window-ref.class';
import { BrowserWindowRef } from '@aca-new/app/shared/refs/browser-window.ref';
import { ClassProvider } from '@angular/core';

export const BROWSER_WINDOW_PROVIDER: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef,
};
